import React from 'react'
import { Modal } from 'react-bootstrap';

export default function ReusableModal(props) {
  const { show, handleClose, size, onEnter, onEntered, onExit } = props;

  return (
    <>
      <Modal
        onClose={handleClose}
        size={size}
        show={show}
        onHide={handleClose}
        centered
        contentClassName="m-auto w-85"
        onEnter={onEnter}
        onEntered={onEntered}
        onExit={onExit}
      >
        <Modal.Body>
          {props.children}
        </Modal.Body>
      </Modal>
    </>
  )
}
